import type { ToggleCustomEvent } from '@ionic/react'
import { ParseKeys } from 'i18next'
import { ComponentProps } from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Toggle } from './styled'

type LabelOnly = {
  label: string
  labelI18n?: never
}

type LabelI18nOnly = {
  label?: never
  labelI18n: ParseKeys
}

type RequiredLabel = LabelOnly | LabelI18nOnly

type SwitchProps = {
  name: string
} & RequiredLabel &
  ComponentProps<typeof Toggle>

export function Switch({
  label,
  labelI18n,
  name,
  ...toggleProps
}: SwitchProps) {
  const { t } = useTranslation()

  return (
    <Controller
      name={name}
      defaultValue={false}
      render={({ field: { onChange, value } }) => {
        return (
          <Toggle
            checked={value}
            onIonChange={(e: ToggleCustomEvent) => {
              onChange(e.detail.checked)
            }}
            {...toggleProps}
            labelPlacement='end'
            justify='start'
            name={name}
          >
            {label ?? (t(labelI18n) as string)}
          </Toggle>
        )
      }}
    />
  )
}
